module.exports = __webpack_public_path__ + "2f94e0a4ba6a34525fa40ddcbf2d9710.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ky/bannerbg.png
// module id = 546
// module chunks = 21